import { useI18n } from '@/hooks/useI18n';
import type { ReactNode } from 'react';

interface OwnerAccessModalProps {
  title: string;
  subtitle?: string;
  onClose: () => void;
  wide?: boolean;
  children: ReactNode;
  footer?: ReactNode;
}

/** Roles & access dialog shell — template u128-modal → owner-access-* */
export const OwnerAccessModal = ({
  title,
  subtitle,
  onClose,
  wide = false,
  children,
  footer,
}: OwnerAccessModalProps) => {
  const { t } = useI18n();
  return (
    <div
      className="owner-access-modal-wrap open"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <section
        className="owner-access-modal"
        style={wide ? { width: 'min(1100px, 100%)' } : undefined}
      >
        <header>
          <div>
            <h2>{title}</h2>
            {subtitle ? <p>{subtitle}</p> : null}
          </div>
          <span className="owner-access-spacer" />
          <button
            type="button"
            className="owner-access-btn"
            onClick={onClose}
            aria-label={t('common.close')}
          >
            ×
          </button>
        </header>
        <div className="owner-access-modal-body">
          {children}
          {footer ? <div className="owner-access-modal-actions">{footer}</div> : null}
        </div>
      </section>
    </div>
  );
};
